// @flow

import React from 'react';
import ComingSoon from '../components/layout/ComingSoon';

type Props = {};

function Contact(props: Props) {
  return <ComingSoon />;
}

export default React.memo<Props>(Contact);
